import { httpV2 } from "@/api";

/**
 * @summary Solicita o status de um conjunto de turbinas.
 * @param {array} monitoringElementIds Ids dos elementos de monitoramento tipo turbina.
 * @returns {array} Status das turbinas (unidade geradora).
 */
const GetList = function(monitoringElementIds)
{
	return httpV2.post("/WindTurbineStatus", monitoringElementIds);
};

/**
 * @summary Solicita os status das conexões de um conjunto de turbinas.
 * @param {array} monitoringElementIds Identificadores dos elementos de monitoramento tipo turbina.
 * @returns {array} Indicações de desconexões.
 */
const GetTurbinesEquipments = function(monitoringElementIds)
{
	return httpV2.post("/WindTurbineStatus/Connection", monitoringElementIds);
};

/**
 * @summary Solicita o status do sensoriamento de uma turbina.
 * @param {number} monitoringElementId Id do elemento de monitoramento tipo turbina.
 * @returns {array} Indicações de falha no sensoriamento.
 */
const GetTurbineSensors = function(monitoringElementId)
{
	return httpV2.get(`/WindTurbineStatus/${monitoringElementId}/Sensors`);
};

/**
 * @summary Solicita os status dos sensoriamentos de um conjunto de turbinas.
 * @param {array} monitoringElementIds Ids dos elementos de monitoramento tipo turbina.
 * @returns {array} Indicações de falha no sensoriamento.
 */
const GetTurbinesSensors = function(monitoringElementIds)
{
	return httpV2.post("/WindTurbineStatus/Sensors", monitoringElementIds);
};

export default
{
	GetList,
	GetTurbineSensors,
	GetTurbinesSensors,
	GetTurbinesEquipments
};